<div class="dd-overlay" (click)="closeEvent($event)">
    <div class="dd-window" (click)="$event.stopPropagation()">
        <section class="dd-header">
            <h2 class="dd-title">{{title}}</h2>
            <button class="dd-close" (click)="closeEvent($event)" aria-label="Cerrar">
                <lucide-icon name="x" [size]="22"></lucide-icon>
            </button>
        </section>

        <div class="dd-body">
            <div *ngIf="events && events.length > 0; else noEvents" class="flex flex-col gap-2">
                <div class="dd-item" *ngFor="let ev of events" (click)="selectEvent.emit(ev)">
                    <span class="dd-dot" [style.background]="ev.color"></span>
                    <span class="dd-time">{{ev.time}}</span>
                    <span class="dd-info">
                        <span class="dd-name">{{ev.title}}</span>
                        <span class="dd-sub" *ngIf="ev.resource">{{ev.resource}}</span>
                    </span>
                    <lucide-icon name="chevron-right" [size]="16" class="dd-chev"></lucide-icon>
                </div>
            </div>
            <ng-template #noEvents>
                <p class="dd-empty">No hay eventos este día</p>
            </ng-template>
        </div>
    </div>
</div>